"use client";
import { useState } from "react";
import PropTypes from "prop-types";
import ContactForm from "@/src/components/project-detail/contact-form-modal/contact-form";
import CompanyDetailSuccessStep from "src/components/company-detail/compay-detail-success-step";
import ErrorStep from "src/components/emlakjet-link/contact-form-modal/error-step";
import { stepNames } from "@/constants/emlakjet-link";

const ProjectDetailContanctForm = ({ projectDetailFormData, isProjectDetailSticky }) => {
  const { INITIAL, SUCCESS, ERROR } = stepNames;
  const [currentStep, setCurrentStep] = useState(INITIAL);
  const handleStep = ({ step }) => setCurrentStep(step);

  const steps = {
    [INITIAL]: (
      <ContactForm
        handleStep={handleStep}
        currentCompany={projectDetailFormData}
        isProjectDetailSticky={isProjectDetailSticky}
      />
    ),
    [SUCCESS]: <CompanyDetailSuccessStep setCurrentStep={setCurrentStep} />,
    [ERROR]: <ErrorStep goBack={() => setCurrentStep(INITIAL)} />,
  };
  return <div>{steps[currentStep]}</div>;
};

ProjectDetailContanctForm.propTypes = {
  projectDetailFormData: PropTypes.object,
  isProjectDetailSticky: PropTypes.bool,
};
export default ProjectDetailContanctForm;
